import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { setGlobalVariable } from "../shared";
import { Accordion } from "rsuite";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";

const Schedule = ({ categories, currentGradingPeriod, activeTab, baseUrl }) => {
  const [intValue, setIntValue] = useState(null);
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);

  const downArrow = require("../icons/downarrow.png");

  //Down arrow
  useEffect(() => {
    const scrollContainer = document.querySelector(".main-content");
    if (!scrollContainer) return;

    const handleScroll = () => {
      const bottom =
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 10;
      setShowScrollIndicator(!bottom);
    };

    scrollContainer.addEventListener("scroll", handleScroll);

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(handleScroll);
    });

    resizeObserver.observe(scrollContainer);

    requestAnimationFrame(handleScroll);

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");

    const headers = {
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      "Content-Type": "application/json", // Optional: Define the content type if needed
    };
    if (token != null) {
      axios
        .get(
          baseUrl +
          `Student/GetHelpPageId?studentkey=${studentkey}&districtId=${districtID}&url=${activeTab}`,
          { headers }
        )
        .then((response) => {
          console.log(response);
          const fetchedValue = response.data;
          setIntValue(fetchedValue);
          setGlobalVariable(fetchedValue);
          console.log("Fetched intValue:", fetchedValue);
        })
        .catch((error) => {
          console.error("Error fetching intValue:", error);
        });
    }
  }, []);

  const [columnDefs] = useState([
    {
      headerName: "Period #",
      field: "Period",
      sort: 'asc', flex: 1, cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Class Name", field: "Description", filter: true,
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      flex: 5, cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Teacher Name", field: "FullName", filter: true,
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      flex: 3, cellStyle: { textAlign: "center" },
    },
  ]);

  const gridOptions = {
    icons: {
      sortAscending: '<span class="ag-icon ag-icon-desc">▲</span>',
      sortDescending: '<span class="ag-icon ag-icon-asc">▼</span>',
    },
  };

  const renderSchedule = () => (
    <div>
      {/* <h2>Schedule</h2> */}
      <Accordion defaultActiveKey={currentGradingPeriod} bordered>
        {Object.entries(categories).map((entry, index) => {
          const category = entry[0];
          const itemList = entry[1];
          let begindate = itemList[0].PeriodBeginDate.replace(/-/g, '/');
          let enddate = itemList[0].PeriodEndDate.replace(/-/g, '/');
          return (
            <Accordion.Panel header={category + " (" + begindate + " - " + enddate + ")"} eventKey={index} key={index}>
              <div className="ag-theme-alpine" style={{ width: "100%" }}>
                <AgGridReact
                  gridOptions={gridOptions}
                  rowData={categories[category]}
                  columnDefs={columnDefs}
                  domLayout="autoHeight"
                  suppressScrollOnNewData={true}
                />
              </div>
              {/* <table className='classTable' border={1}>
                  <tbody>
                    <tr>
                      <th style={{ padding: '5px' }}>#</th>
                      <th style={{ padding: '5px' }}>Class Name</th>
                      <th style={{ padding: '5px' }}>Teacher Name</th>
                    </tr>
                    {itemList.map((item, i) => (
                      <tr key={i}>
                        <td style={{ padding: '5px' }}>{i + 1}</td>
                        <td style={{ padding: '5px' }}>{item.Description}</td>
                        <td style={{ padding: '5px' }}>{item.FullName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table> */}
            </Accordion.Panel>
          );
        })}
      </Accordion>
    </div>
  );

  return (<>
    <div>{renderSchedule()}</div>;

    {showScrollIndicator && (
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          background: "#d0cfcf99",
          color: "white",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "22px",
          zIndex: 9999,
          cursor: "pointer",
          animation: "bounce 1.5s infinite",
        }}
        onClick={() =>
          window.scrollBy({ top: 200, behavior: "smooth" })
        }
      >
        <img
          src={downArrow}
          alt="Scroll down"
          style={{ width: "22px", height: "22px" }}
        />
      </div>
    )}

  </>)
};

export default Schedule;
